<template>
  <div class="AirStrategyCom">
    <div class="leftBox">
      <div class="btnsBox">
        <el-button
          size="small"
          :disabled="!treeAllData.treeActive?.id.id"
          @click="carryOut"
          :loading="loadingBtn"
          >执行</el-button
        >
        <el-button size="small" @click="saveData">保存</el-button>
        <el-button
          size="small"
          @click="
            dialogInfo = {};
            dialogVisible = true;
          "
          >保存为新策略</el-button
        >
      </div>
      <div class="tabsBox ashComWrap">
        <el-tabs
          v-model="activeName"
          style="width: 98%; height: 98%"
          type="card"
        >
          <el-tab-pane
            v-for="(v, i) in strategyData.strategyInfo"
            :key="i"
            :label="v.baseName"
            :name="v.baseId"
          >
            <div>
              <el-button
                v-for="c in typeList"
                :key="c.value"
                :type="v.type === c.value ? 'primary' : ''"
                size="mini"
                @click="changeType(i, c.value)"
              >
                {{ c.name }}</el-button
              >
            </div>
            <ul>
              <template v-if="v.detailsList.length">
                <li v-for="(item, index) in v.detailsList" :key="index">
                  <ControlPanel :list="item" />
                </li>
              </template>
            </ul>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="rightBox ashComWrap">
      <StrategyInfo :strategyData="treeAllData.treeActive" />
      <StrategyRecord
        :strategyId="
          treeAllData.treeActive.id ? treeAllData.treeActive.id.id : ''
        "
      />
    </div>
    <StrategyDialog
      v-if="dialogVisible"
      :dialogInfo="dialogInfo"
      @saveStrategy="saveStrategy"
    />
  </div>
</template>

<script>
import api from "@/api";
import ControlPanel from "@/components/zixitong/airSystem/control/ControlPanel.vue";
import StrategyInfo from "@/components/zixitong/airSystem/control/StrategyInfo.vue";
import StrategyRecord from "@/components/zixitong/airSystem/control/StrategyRecord.vue";
import StrategyDialog from "@/components/zixitong/airSystem/control/StrategyDialog.vue";
export default {
  props: {
    treeAllData: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    ControlPanel,
    StrategyInfo,
    StrategyRecord,
    StrategyDialog,
  },
  watch: {
    treeAllData: {
      handler(newvalue, oldvalue) {
        // console.log(this.treeAllData);
        this.getAllStrategy();
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      activeName: "",
      strategyData: {},
      dialogVisible: false,
      dialogInfo: {},
      typeList: [
        { name: "不加入策略", value: "NOT_PARTICIPATING" },
        { name: "供冷策略", value: "COOLING" },
        { name: "供暖策略", value: "HEATING" },
      ],
      loadingBtn: false,
    };
  },
  methods: {
    // 执行策略
    async carryOut() {
      this.loadingBtn = true;
      let res = await api.ACRStrategyCarryOut({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        strategyId: this.treeAllData.treeActive.id.id,
      });
      // console.log(res);
      if (res && res.data.code == 200) {
        this.loadingBtn = false;
        this.$message.success("执行成功!");
        this.$emit("listenInRenew");
      } else {
        this.loadingBtn = false;
      }
    },
    // 切换策略模式
    changeType(index, activeKey) {
      if (this.strategyData.strategyInfo[index].type !== activeKey) {
        this.$confirm(
          "切换策略或不加入策略,编辑的策略会失效, 请谨慎操作?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            this.strategyData.strategyInfo[index].type = activeKey;
            this.getStrategy();
          })
          .catch(() => {});
      }
    },
    saveData() {
      this.dialogInfo = this._.cloneDeep(this.strategyData);
      this.dialogVisible = true;
    },
    async saveStrategy(data) {
      let newData = this._.cloneDeep(this.strategyData);
      let res = await api.ACRSaveStrategy({
        id: data.id,
        tenantId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .tenantId,
        name: data.name,
        remark: data.remark,
        strategyInfo: newData.strategyInfo,
      });
      if (res && res.data.code == 200) {
        this.$emit("listenInRenew");
        this.dialogVisible = false;
        this.$message.success("保存成功!");
      }
    },
    async getAllStrategy() {
      this.$store.commit("SET_LOADING", true);
      let res = await api.ACRSearchStrategyList({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        strategyId: this.treeAllData.treeActive?.id.id ?? "",
      });
      if (res && res.data.code == 200) {
        this.$store.commit("SET_LOADING", false);
        this.strategyData = res.data.data;
        this.activeName = this.strategyData.strategyInfo.length
          ? this.strategyData.strategyInfo[0].baseId
          : "";
      }
    },
    async getStrategy() {
      this.$store.commit("SET_LOADING", true);
      let index = this.strategyData.strategyInfo.findIndex((v) => {
        return v.baseId === this.activeName;
      });
      let strategyType = this.strategyData.strategyInfo[index].type;
      let assetId = this.activeName;
      this.strategyData.strategyInfo[index].detailsList = [];
      let res = await api.ACRSearchStrategyList({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        assetId: assetId,
        strategyType: strategyType,
        strategyId: this.treeAllData.treeActive?.id.id ?? "",
      });
      if (res && res.data.code == 200) {
        this.$store.commit("SET_LOADING", false);
        this.activeName = assetId;
        this.strategyData.strategyInfo[index].detailsList = res.data.data;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.AirStrategyCom {
  @include setCenterWH;
  @include setFlexBetween;
  .leftBox {
    width: calc(75% - 12px);
    height: 100%;
    @include setFlexColumn;
    justify-content: space-between;
    .btnsBox {
      height: 50px;
      width: 100%;
      @include setFlexStart;
    }
    .tabsBox {
      width: 100%;
      height: calc(100% - 58px);
      @include setFlexCenter;
      ::v-deep .el-tabs__content {
        width: 100%;
        height: calc(100% - 60px);
        .el-tab-pane {
          width: 100%;
          height: 100%;
        }
      }
      ul {
        width: 100%;
        height: calc(100% - 60px);
        margin-top: 12px;
        @include setFlexStart;
        align-items: flex-start;
        align-content: flex-start;
        flex-wrap: wrap;
        overflow: auto;
        li {
          width: calc(50% - 17px);
          background: #fff;
          border-radius: 6px;
          margin: 0 15px 10px 0;
          border: 1px solid #ebeef5;
          box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
        }
      }
    }
  }
  .rightBox {
    width: 25%;
    height: 100%;
  }
}
</style>
